import { lazy, LoadableComponent } from '@loadable/component'
import type { ComponentType, ReactNode } from 'react'
import { featureFlags } from 'config/feature-flags'

export interface LoadableConfig {
  fallback?: ReactNode
}

export interface RouteConfig {
  path: string
  Component: LoadableComponent<ComponentType<any>>
  exact?: boolean
}

export default function getRoutes(config?: LoadableConfig): RouteConfig[] {
  const lazyWithConfig = lazy as any
  const routes: RouteConfig[] = [
    {
      path: '/admin/users',
      Component: lazyWithConfig(() => import('pages/admin/users'), config),
    },
    {
      path: '/admin/groups',
      Component: lazyWithConfig(() => import('pages/admin/groups'), config),
    },
    {
      path: '/admin/templates',
      Component: lazyWithConfig(() => import('pages/admin/templates'), config),
    },
    {
      path: '/admin/activity',
      Component: lazyWithConfig(() => import('pages/admin/activity'), config),
    },
    featureFlags.adminSecurity && {
      path: '/admin/security',
      Component: lazyWithConfig(() => import('pages/admin/security'), config),
    },
  ].filter(Boolean) as RouteConfig[]

  return routes
}
